<template>
  <v-slide-y-transition mode="out-in">
    <MeetingReception
      v-if="status === 'reception'"
      :inspection="inspection"
      @join="goToMeeting"
      @update-username="updateUsername"
    />
    <MeetingConference
      v-else-if="status === 'meeting'"
      :inspection="inspection"
      :guestUsername="guestUsername"
      @leave-inspection="gotToExit"
    />
    <MeetingExit
      v-else-if="status === 'exit'"
      @goToReception="goToReception"
    />
  </v-slide-y-transition>
</template>

<script>
import { MeetingReception, MeetingConference, MeetingExit } from "@/components"
export default {
  name: "Meeting",
  components: { MeetingReception, MeetingConference, MeetingExit },
  props: {
    inspection: { type: Object, required: true }
  },
  data() {
    return {
      status: "reception",
      guestUsername: ""
    }
  },
  methods: {
    gotToExit() {
      this.status = "exit"
    },
    goToMeeting() {
      this.status = "meeting"
    },
    goToReception(value) {
      if (value) {
        this.status = "reception"
      } else {
        this.$router.push({ name: "Inspections" })
        // this.$router.push({ name: "Projects" })
      }
    },
    updateUsername(username) {
      this.guestUsername = username
    }
  }
}
</script>
